export enum incidentTypes {
    LOADING = "LOADING",
    SELECTED_INCIDENT = "SELECTED_INCIDENT",
    GET_INCIDENT_LIST = "GET_INCIDENT_LIST",
}
  
export default incidentTypes;